import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
} from '@angular/core';
import { FullTextSearch } from './fulltext-search';
import { FormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import Toastify, { Options } from 'toastify-js';
import * as PotentialIcons from '../../../ngx-aevo-icons/src/lib/icons/icons';
import {
    AevoIcon,
    aevoIcon,
} from '../../../ngx-aevo-icons/src/lib/icons/icons';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

type IconSafe = { data: SafeHtml; name: aevoIcon };

const allIcons = Object.values(PotentialIcons).filter((v) => v.name && v.data);

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    readonly fullTextService = new FullTextSearch(allIcons);
    readonly toastConfig: Options = {
        text: 'Nome copiado com sucesso!',
        duration: 3000,
        close: true,
        gravity: 'bottom',
        position: 'right',
        style: {
            background: '#f2722a',
        },
    };
    readonly iconSet: IconSafe[] = (<AevoIcon[]>allIcons).map((icon) => ({
        ...icon,
        data: this.domSanitizer.bypassSecurityTrustHtml(icon.data),
    }));
    readonly searchControl = new FormControl('');
    matchedIcons = new Set<string>();

    constructor(
        private readonly domSanitizer: DomSanitizer,
        private readonly changeDetector: ChangeDetectorRef
    ) {
        this.matchedIcons = new Set(this.iconSet.map((i) => i.name));
        this.searchControl.valueChanges
            .pipe(
                debounceTime(150),
                distinctUntilChanged(),
                tap((term) => (this.matchedIcons = this.filterIcons(term))),
                tap(() => changeDetector.markForCheck())
            )
            .subscribe();
    }

    trackBy(index: number, icon: IconSafe) {
        return icon.name;
    }

    async toastSelected(icon: IconSafe) {
        await navigator.clipboard.writeText(icon.name);
        Toastify(this.toastConfig).showToast();
    }

    private filterIcons(term: string) {
        if (!term.trim()) {
            return new Set(this.iconSet.map((i) => i.name));
        }

        const searchTerm = term.toLowerCase();
        const matchItems = this.fullTextService.filter(searchTerm);
        return new Set(matchItems.map(({ name }) => name.toLowerCase()));
    }
}
